import { Fragment } from 'react';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIList from 'UIComponents/list/UIList';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import TaskFormHeader from './TaskFormHeader';
import CloseButton from '../buttons/CloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TaskFormLoading = ({
  edit,
  BodyComponent = ({
    children: bodyChildren
  }) => /*#__PURE__*/_jsx(PanelBody, {
    children: /*#__PURE__*/_jsx(PanelSection, {
      children: bodyChildren
    })
  }),
  HeaderComponent = PanelHeader,
  FooterComponent = PanelFooter,
  onClose
}) => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(HeaderComponent, {
      children: [/*#__PURE__*/_jsx(TaskFormHeader, {
        edit: edit
      }), onClose && /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(BodyComponent, {
      children: /*#__PURE__*/_jsx(UILoadingSpinner, {
        layout: "centered",
        size: "medium",
        minHeight: 300
      })
    }), /*#__PURE__*/_jsx(FooterComponent, {
      children: /*#__PURE__*/_jsx(UIList, {
        inline: true,
        children: /*#__PURE__*/_jsx(CloseButton, {
          onClose: onClose
        })
      })
    })]
  });
};
export default TaskFormLoading;